import {
  HOMEPAGE_ROUTE,
  USERS_ROUTE,
  ORGANIZATIONS_ROUTE,
  APPS_ROUTE,
  ROUTE_TITLE,
} from '@App/constantes'

import iconUsersSvg from '@App/assets/icon-users.svg'
import iconMetricsSvg from '@App/assets/icon-metrics.svg'
import iconOrganizationsSvg from '@App/assets/icon-organizations.svg'
import iconSiteSvg from '@App/assets/icon-site.svg'
import { Segments } from '@App/store/segment/types'

export interface IRoutes {
  showedInMenu: boolean
  role: number
  path: string
  title: string
  icon: string,
  segment?: Segments
}

const routes: IRoutes[] = [
  {
    showedInMenu: true,
    path: HOMEPAGE_ROUTE,
    role: 1,
    title: ROUTE_TITLE.Dashboard,
    icon: iconMetricsSvg,
  },
  {
    showedInMenu: true,
    path: ORGANIZATIONS_ROUTE,
    role: 100,
    title: ROUTE_TITLE.Organizations,
    icon: iconOrganizationsSvg,
  },
  {
    showedInMenu: true,
    path: APPS_ROUTE,
    role: 100,
    title: ROUTE_TITLE.Applications,
    icon: iconSiteSvg,
  },
  {
    showedInMenu: true,
    path: USERS_ROUTE,
    role: 50,
    title: ROUTE_TITLE.Users,
    icon: iconUsersSvg,
    segment: Segments.USERS_READ,
  },
]

export default routes
